const MM_PER_IN = 25.4; // 1 inch = 25.4 mm
const CSS_PX_PER_IN = 96; // 1 inch = 96 px
const mmToCssPx = (mm: number) => (mm / MM_PER_IN) * CSS_PX_PER_IN;

const A6_W = Math.round(mmToCssPx(105)); // 105 mm = 397.6378 px

export const NE_LABEL_WIDTH = A6_W;
